import { Col, Row } from "antd";
import { LAYOUT_TYPE } from "./AddRoutesJson";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "./../../components/navbar/Navbar";
import LogoNavbar from "../../components/logo-navbar/LogoNavbar";

function LayoutWrapper({ layoutIdentifier, children }) {
  switch (layoutIdentifier) {
    case LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT:
      return (
        <Row>
          <Col lg={4} xs={24}>
            <Sidebar />
          </Col>
          <Col lg={20} xs={24}>
            <Navbar />
            <div className="lg:p-5">{children}</div>
          </Col>
        </Row>
      );
    case LAYOUT_TYPE.LOGO_HEADER_LAYOUT:
      return (
        <Row>
          <Col lg={24} xs={24}>
            <LogoNavbar />
            <div>{children}</div>
          </Col>
        </Row>
      );
    default:
      return <div>{children}</div>;
  }
}

export default LayoutWrapper;
